import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import moment from "moment";

export default function Details({ restaurant }) {
  const { loadingFeedback, restaurantFeedback } = useSelector(
    (state) => state.publicRestaurant
  );

  const daysOfWeek = [
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
    "sunday",
  ];
  const [arrangedOperatingTime, setArrangedOperatingTime] = useState([]);

  useEffect(() => {
    if (restaurant?.restaurant_operating_time) {
      const newOperatingTime = daysOfWeek.map((day) => ({
        [day]: restaurant?.restaurant_operating_time[day],
      }));
      setArrangedOperatingTime(newOperatingTime);
    }
    // eslint-disable-next-line
  }, [restaurant?.restaurant_operating_time]);

  return (
    <div data-test="Restaurant-details">
      <section aria-labelledby="section-2-title">
        <h2 className="sr-only" id="section-2-title">
          Restaurant Information
        </h2>
        <div>
          {/* Your content */}
          <h3 className="text-xl font-medium mb-6">Restaurant Information</h3>
          <div className="mb-6">
            <h4 className="mb-1 text-lg">Address</h4>
            <p className="mb-2 text-[#676565] dark:text-[#BCBCBC]">
              {restaurant?.restaurant_address}, {restaurant?.restaurant_state},{" "}
              {restaurant?.restaurant_country}
            </p>
          </div>
          <div className="mb-6">
            <h4 className="mb-1 text-lg">Open Times</h4>

            {restaurant?.restaurant_operating_time ? (
              arrangedOperatingTime.map((time, i) => {
                return (
                  <div key={i} className="mb-1">
                    {Object.keys(time).map((key, i) => {
                      return (
                        <div key={i + key} className="mb-1">
                          <span className="capitalize">{key}</span> (
                          <span>
                            {restaurant?.restaurant_operating_time[key].open} -{" "}
                            {restaurant?.restaurant_operating_time[key].close}
                          </span>
                          )
                        </div>
                      );
                    })}
                  </div>
                );
              })
            ) : (
              <p className="text-[#676565] dark:text-[#BCBCBC]">
                Not available
              </p>
            )}
          </div>
          <div className="mb-6">
            <h4 className="mb-1 text-lg">Phone</h4>
            <p className="text-[#676565] dark:text-[#BCBCBC]">
              {restaurant?.restaurant_phone
                ? `${restaurant?.restaurant_phone.slice(
                    0,
                    5
                  )}XXXX${restaurant?.restaurant_phone.slice(-4)}`
                : "--"}
            </p>
          </div>
          <div className="mb-6">
            <h4 className="mb-1 text-lg">Categories</h4>
            <a href="/" className="text-primary-500">
              {restaurant?.restaurant_categories &&
                restaurant?.restaurant_categories.map((category, i) => (
                  <span key={category + i}>
                    <span>{category}</span>
                    {i < restaurant?.restaurant_categories?.length - 1 ? (
                      <span>, </span>
                    ) : (
                      ""
                    )}
                  </span>
                ))}
            </a>
          </div>
        </div>

        <div className="mt-12">
          {/* Your content */}
          <h3 className="text-xl font-medium mb-6">
            Reviews (
            {restaurantFeedback?.feedbacks?.length > 0 ? "Latest" : "0"})
          </h3>

          <div className="mb-6">
            {loadingFeedback ? (
              ""
            ) : (
              <>
                {restaurantFeedback?.feedbacks?.length > 0 ? (
                  restaurantFeedback?.feedbacks.map((feedback, i) => (
                    <div key={i} className="mb-6">
                      <div className="flex items-center justify-between gap-4">
                        <div className="flex items-center gap-3 mb-1">
                          <img
                            src={feedback?.user?.picture}
                            alt="feedback"
                            className="w-[24px] h-[24px] object-cover rounded-full"
                          />
                          <p className="capitalize">{feedback?.user?.name}</p>
                        </div>
                        <p>
                          {moment(feedback?.created_at).format("MMM DD, YYYY")}
                        </p>
                      </div>
                      <p className="break-all">{feedback?.description}</p>
                    </div>
                  ))
                ) : (
                  <p className="text-[#676565] dark:text-[#BCBCBC] ">
                    No feedback available
                  </p>
                )}
              </>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}
